var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHbA1C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.526 9.53906C14.6541 9.53906 14.7767 9.5915 14.8651 9.68416C14.9456 9.76847 16.8359 11.7708 16.8359 13.6896C16.8359 14.9632 15.7997 15.9994 14.526 15.9994C13.2525 15.9994 12.2164 14.9632 12.2164 13.6895C12.2164 11.7708 14.1065 9.76844 14.1869 9.68416C14.2754 9.5915 14.3979 9.53906 14.526 9.53906Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02649 8.46875H9.28484C10.5356 8.51744 10.5349 10.3054 9.28484 10.3542H7.02649C5.78118 10.3061 5.77099 8.52062 7.02649 8.46875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02649 11.293H9.28484C10.5357 11.3417 10.5349 13.1296 9.28484 13.1784H7.02649C5.78059 13.1302 5.77159 11.3445 7.02649 11.293Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0604 5.64456C17.3098 5.69475 17.3114 7.48041 16.0604 7.52997H7.02704C6.69038 7.52997 6.36757 7.61816 6.08432 7.78284V5.93319L6.3702 5.64453H16.0604V5.64456Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02651 14.1133H9.28485C10.5356 14.162 10.5349 15.9499 9.28485 15.9987H7.02651C5.78116 15.9506 5.77101 14.1651 7.02651 14.1133Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36667 0.137219C7.46017 0.0437187 7.57857 0 7.69567 0C8.39976 0 8.69404 1.97263 7.53176 3.14663L5.28292 5.41184C5.19601 5.49963 5.14726 5.61816 5.14726 5.74166V8.00056C5.14726 9.29834 4.09145 10.3542 2.79367 10.3542C2.53479 10.3542 2.32464 10.564 2.32464 10.8229C2.32464 11.0818 2.53423 11.2917 2.7931 11.2917C3.79242 11.2917 4.68889 10.8441 5.29304 10.1392C5.44104 10.4916 5.65954 10.7111 5.78598 10.8228C4.93873 11.5482 4.93739 12.9188 5.78598 13.6457C5.1101 14.2258 4.95442 15.2493 5.40045 15.9999H0.946229C0.434291 15.9999 0.00350952 15.5856 0.00350952 15.0569V6.50044L7.36667 0.137219Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHbA1C);
export default __webpack_public_path__ + "static/media/hbA1c.19b8728eaad39d74f4b9fbea88faaa83.svg";
export { ForwardRef as ReactComponent };